import { Header } from "./components/header";
import { Base } from "./step.base";

export const Step = Object.assign(Base, {
    Header
});
